import { default as customer } from './customer/services'
import { default as customerContract } from './contract/services'
import { default as customerContact } from './contact/services'
import { default as customerContractStatus } from './contract-status/services'

export default { 
	customer,
	customerContract,
	customerContact,
	customerContractStatus
}
